import { Row, Col } from 'react-bootstrap';
import { Column } from 'primereact/column'
import { useContext, useState, useEffect, useRef } from 'react';
import Card from '../../ui/Card';
import CurrentIssuerMainContact from '../adminCommon/issuerMainContactCurrent';
import NewIssuerMainContact from '../adminCommon/issuerMainContactNew';
import CurrentIssueAuthorizations from '../adminCommon/issueAuthorizationCurrent';
import NewIssueAuthorizations from '../adminCommon/issueAuthorizationNew';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';
import SecurityContainer from '../securityContainer';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { useParams } from "react-router-dom";
import AdminService from "../../../services/AdminService";

const ProposedDebtIssuerUpdate = (props) => {
  const user = useContext(UserContext);
  const params= useParams();
  const pageType = params.pageType;

  const currentIssueContactRef = useRef(null);  //pointer to CurrentIssuerMainContact  to refresh grid after adding, approve, reject, or cancel.
  const newIssueContactRef = useRef(null);  //pointer to NewIssuerMainContact to refresh grid after adding, approve, reject, or cancel.
  const currentIssueAuthorizationRef = useRef(null); //pointer to CurrentIssueAuthorizations to refresh grid after adding, approve, reject, or cancel.
  const newIssueAuthorizationRef = useRef(null);  //pointer to NewIssueAuthorizations to refresh grid after adding, approve, reject, or cancel.

  const issuerClearRef = useRef(null);
  const contactClearRef = useRef(null);
  const AuthorizationClearRef = useRef(null);
  const contactIdRef = useRef(null);
  const authorizationIdRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [issuers, setIssuers] = useState([]);  //Issuer list
  const [contacts, setContacts] = useState([]); //Contacts list
  const [authorizations, setAuthorizations] = useState([]); //Authorizations list
  const [cdiacNumbers, setCdiacNumbers] = useState([]); //CDIAC Number list

  const [proposeDebtId, setProposeDebtId] = useState("");
  const [proposeDebt, setProposeDebt] = useState([]); //Existing current Proposed Debt with old Issuer Id
  const [newProposeDebt, setNewProposeDebt] = useState([]); //New Proposed Debt with new Issuer Id in Review table
  const [issueAuthorizations, setIssueAuthorizations] = useState([]); //Existing issue authorizations in Issue Authorization table
  const [newIssueAuthorizations, setNewIssueAuthorizations] = useState([]); //New issue authorizations in Review table
  const [issuerContact, setIssuerContact] = useState([]); //Existing main issue contact in Issue Contact Assoc table
  const [newIssuerContact, setNewIssuerContact] = useState([]); //New main issue contact in Review table

  const [addIssuerError, setAddIssuerError] = useState("");
  const [addIssuerContactError, setAddIssuerContactError] = useState("");
  const [addIssueAuthorizationError, setAddIssueAuthorizationError] = useState("");
  const [cancelIssuerError, setCancelIssuerError] = useState("");
  
  const [newIssuer, setNewIssuer] = useState([]); //New issuer in Issuer table
  const [newAuthorization, setNewAuthorization] = useState([]); //New authorization in Authorization_Ref table
  const [cdiacNumber, setCdiacNumber] = useState("");
  let reportType = "RPD";
  let tableType = "Review";
  const reviewHistory = {
    "proposeDebtId": null,
    "finalSaleId": null,
    "updateType" : "Issuer",
    "reviewStatusFlag": "",                        
    "createUser": CommonService.getUserName(user)                        
  }


  const handleCdiacChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    const selectedCdiacNumber = e.length > 0 ? e[0]['cdiacNumber'] : '';
    setProposeDebtId(checkValue);
    setCdiacNumber(selectedCdiacNumber);
    if (checkValue) {
      setAddIssuerError('');
      setCancelIssuerError('');
      setAddIssuerContactError('');
      setAddIssueAuthorizationError('');
      if(pageType === "Update") {
        issuerClearRef?.current?.clear();
        contactClearRef?.current?.clear();
        AuthorizationClearRef?.current?.clear();
      }
      getProposeDebtById(checkValue);
      getNewProposeDebtById(checkValue);
    }
  }


  const handleIssuerChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    if (checkValue) {
      setAddIssuerError('');
      setAddIssueAuthorizationError('');
      if(pageType === "Update") {
        AuthorizationClearRef?.current?.clear();
      }
      getNewIssuer(checkValue);
      getIssuerAuthorizations(checkValue);
    }
  }


  const handleContactChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    contactIdRef.current = checkValue;
    setAddIssuerContactError('');
  }


  const handleAuthorizationChange = (e, key) => {
    const checkValue = e.length > 0 ? e[0][key] : '';
    
    if (checkValue) {
      authorizationIdRef.current = checkValue;
      setAddIssueAuthorizationError('');
      setAddIssuerError('');
      getNewAuthorization(checkValue);
      
    }
  }


  const handleAddIssuerBtn = (e) => {
    if (!proposeDebtId) {
      setAddIssuerError('Please select CDIAC number');
      return;
    }
    if (!newIssuer || newIssuer.length === 0) {
      setAddIssuerError('Please select an issuer');
      return;
    }
     if (newIssuer.issuerId === proposeDebt[0].issuerId) {
      setAddIssuerError('Proposed Debt already has issuer. Please select a different issuer');
      return;
    }

    setAddIssuerError('');

    //Call backend code to create the new propose debt in review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "addNewProposeDebtIssuer",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "proposeDebt": {
                            "proposeDebtId": proposeDebt[0].proposeDebtId,
                            "issuerId": newIssuer.issuerId,
                            "issueName" : proposeDebt[0].issueName,
                            "issueStatusFlag": proposeDebt[0].issueStatusFlag,
                            "proposedSaleDate": proposeDebt[0].proposedSaleDate,
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user),
                }
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("New issuer added successfully!");
                    //Also call the backend to get the newly created propose debt
                    getNewProposeDebtById(proposeDebtId);
                    issuerClearRef?.current?.clear();
                }

            });
    
  }


  const handleAddContactBtn = (e) => {
    if (!proposeDebtId) {
      setAddIssuerContactError('Please select CDIAC number');
      return;
    }
    if (!newProposeDebt || newProposeDebt.length === 0) {
      setAddIssuerContactError('Please add an issuer before adding a contact');
      return;
    }
    if (!contactIdRef.current) {
      setAddIssuerContactError('Please select a contact');
      return;
    }

    setAddIssuerContactError('');

    //Call backend code to create the new issue contact assoc in review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "addNewIssueContactIssuerUpdate",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "issueContactAssoc": {
                            "proposeDebtId": issuerContact[0].proposeDebtId,
                            "finalSaleId": issuerContact[0].finalSaleId,
                            "contactId": contactIdRef.current,
                            "roleCodeId" : issuerContact[0].roleCodeId,
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user),
                },
                "reportType" : "RPD",
                "tableType" : "Review"
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("New contact added successfully!");
                    //Also call the backend to get the newly created main contact
                    newIssueContactRef.current.getNewIssueContactById(proposeDebtId);
                }

                contactClearRef?.current?.clear();
                contactIdRef.current = '';

            });
    
  }


  const handleAddAuthorizationBtn = (e) => {
    if (!proposeDebtId) {
      setAddIssueAuthorizationError('Please select CDIAC number');
      return;
    }
    if (!newProposeDebt || newProposeDebt.length === 0) {
      setAddIssueAuthorizationError('Please add an issuer before connecting Authorization');
      return;
    }
    if (!authorizationIdRef.current) {
      setAddIssueAuthorizationError('Please select an authorization');
      return;
    }
    if (newProposeDebt[0].issuerId !== newAuthorization.issuerId) {
      setAddIssueAuthorizationError('Please select an Authorization that belongs to the added issuer');
      return;
    }

    setAddIssueAuthorizationError('');
    
    //Call backend code to bulk create the new issue authorization in review table
    var obj = {
            msgId: null,
            sysId: null,
            opr: "postIssueAuthorizationIssuerUpdate", 
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "issueAuthorization": {
                            "proposeDebtId": newProposeDebt[0].proposeDebtId,
                            "finalSaleId": null,
                            "authorizationId": newAuthorization.authorizationId,
                            "issuerId" : newAuthorization.issuerId,
                            "originalAuthorizedAmt": newAuthorization.authorizationAmt,
                            "authorizationDate": newAuthorization.electionDate,
                            "authorityReplenishAmt": "0.00",
                            "authorityReducedAmt": "0.00",
                            "createUser": CommonService.getUserName(user),
                            "lastUpdateUser": CommonService.getUserName(user),
                },
                "tableType": tableType,
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Issuer authorization added successfully!");
                    //Also call the backend to get the newly created authorizations
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(proposeDebtId);
                }

                AuthorizationClearRef?.current?.clear();
                authorizationIdRef.current = '';

            });
    
  }


  const handleCancelChangesBtn = (e) => {
    if (proposeDebtId === '') {
      setCancelIssuerError('Please select CDIAC number');
      return;
    }
    if (!newProposeDebt || newProposeDebt.length === 0) {
      setCancelIssuerError('Selected Report of Proposed Debt does not have any changes to cancel');
      return;
    }

    setCancelIssuerError('');

    //Call backend code to cancel all data for the selected propose Debt report from the review tables
    var obj = {
            msgId: null,
            sysId: null,
            opr: "cancelRejectProposeDebtIssuerUpdate",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "proposeDebtId" : proposeDebtId
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Changes cancelled successfully!");
                    //Also call the backend to refresh new grids to show that cancelled review data have been deleted
                    getNewProposeDebtById(proposeDebtId);
                    newIssueContactRef.current.getNewIssueContactById(proposeDebtId);
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(proposeDebtId);
                }

            });
    
  }


  const handleApproveIssuerUpdateBtn = (e) => {
    if (proposeDebtId === '') {
      setAddIssuerError('Please select CDIAC number');
      return;
    }
    if (!newProposeDebt || newProposeDebt.length === 0) {
      setAddIssuerError('Selected Report of Proposed Debt does not have any New Issuer to approve');
      return;
    }
    if (!newIssuerContact || newIssuerContact.length === 0) {
      setAddIssuerError('Selected Report of Proposed Debt does not have any New Main Contact to approve');
      return;
    }
    if (!newIssueAuthorizations || newIssueAuthorizations.length === 0) {
      setAddIssuerError('Selected Report of Proposed Debt does not have any New Issuer Authorizations to approve');
      return;
    }

    setAddIssuerError('');

    //Call backend code to save the new approved issuer and related data in Proposed Debt and other tables and delete them from the review tables
    var obj = {
            msgId: null,
            sysId: null,
            opr: "approveProposeDebtIssuerReview",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                "newProposeDebt": newProposeDebt,
                "newIssuerContact": newIssuerContact,  //New main issue contact in Review table
                "newIssueAuthorizations": newIssueAuthorizations  //New issue authorizations in Review table 
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Approval of Issuer update was successful!");
                    //Create Review History data
                    reviewHistory.proposeDebtId = proposeDebtId;
                    reviewHistory.reviewStatusFlag = "A";
                    AdminService.saveReviewHistory(reviewHistory);
                    //Also call the backend to refresh all grids to reflect the aprroved issuer update
                    getProposeDebtById(proposeDebtId);
                    getNewProposeDebtById(proposeDebtId);
                    currentIssueContactRef.current.getIssueContactById(proposeDebtId);
                    newIssueContactRef.current.getNewIssueContactById(proposeDebtId);
                    currentIssueAuthorizationRef.current.getIssueAuthorizationsByReportId(proposeDebtId);
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(proposeDebtId);
                }

            });
    
  }


  const handleRejectIssuerUpdateBtn = (e) => {
    if (proposeDebtId === '') {
      setAddIssuerError('Please select CDIAC number');
      return;
    }
    if (!newProposeDebt || newProposeDebt.length === 0) {
      setAddIssuerError('Selected Report of Proposed Debt does not have New Issuer to reject');
      return;
    }

    setAddIssuerError('');

    //Call backend code to delete the rejected new data from the review tables
    var obj = {
            msgId: null,
            sysId: null,
            opr: "cancelRejectProposeDebtIssuerUpdate",
            hdrStruct: null,
            queryParam: null,
            reqData: {
                 "proposeDebtId" : proposeDebtId,
            },

        };

        BaseService.processRequest(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0) {
                    toast.error(result.data.errors[0].message);
                }
                else {
                    toast.success("Rejection of Issuer update was successful!");
                    //Create Review History data
                    reviewHistory.proposeDebtId = proposeDebtId;
                    reviewHistory.reviewStatusFlag = "R";
                    AdminService.saveReviewHistory(reviewHistory);
                    //Also call the backend to refresh new grids to show that rejected review data have been deleted
                    getNewProposeDebtById(proposeDebtId);
                    newIssueContactRef.current.getNewIssueContactById(proposeDebtId);
                    newIssueAuthorizationRef.current.getNewIssueAuthorizationsById(proposeDebtId);
                }

            });
    
  }


  useEffect(() => {
    getCdiacNumbers();
    getIssuers();
    getContacts();
  }, []);


  const getCdiacNumbers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getCdiacProposed",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "updateType": "Issuer"
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setCdiacNumbers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getIssuers = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getIssuers",
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setIssuers(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getContacts = () => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAllContacts",  //Also used in updateAdtr/editAdtr component
      hdrStruct: null,
      queryParam: null,
      reqData: {},
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setContacts(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }

  
const getIssuerAuthorizations = (selectedIssuerId) => {   //Get list of authorizations for the selected Issuer or new propose Debt issuer.
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAuthorizationRefsByIssuerId",  
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "issuerId": selectedIssuerId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAuthorizations(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getNewIssuer = (selectedIssuerId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getIssuerByIssuerId",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "issuerId": selectedIssuerId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewIssuer(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  const getNewAuthorization = (selectedAuthorizationId) => {  //Get detail information on the selected authorization used for add issuer authorization in review table.
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAuthorizationRef",  //Existing operation
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "authorizationId": selectedAuthorizationId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewAuthorization(result.data.responses[key]);
        });
        setIsLoading(false);
      });

  }


  const getProposeDebtById = (selectedProposeDebtId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getProposedDebtById",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "proposeDebtId": selectedProposeDebtId,
        "tableType": "Normal",
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setProposeDebt(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }


  const getNewProposeDebtById = (selectedProposeDebtId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getProposedDebtById",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "proposeDebtId": selectedProposeDebtId,
        "tableType": "Review",
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
          const respondData = result.data.responses[0];
          getIssuerAuthorizations(respondData[0]?.issuerId);
          setNewProposeDebt(respondData);
          setIsLoading(false);
          
        
      });
  }


  const columnsProposeDebt = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  },{
    dataField: 'proposedSaleDate',
    text: 'Proposed Sale Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.proposedSaleDate),
  },{
    dataField: 'issueName',
    text: 'Issue Name',
    sort: true,
  },
  ];


  const  columnsNewProposeDebt = [{
    dataField: 'issuerName',
    text: 'Issuer Name',
    sort: true,
  },{
    dataField: 'proposedSaleDate',
    text: 'Proposed Sale Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.proposedSaleDate),
  },{
    dataField: 'issueName',
    text: 'Issue Name',
    sort: true,
  },
  ];


  return (
    <SecurityContainer>
      <form onSubmit={(e) => e.preventDefault()}>
        <Card>
          <div className="panel panel-default">
            <div className="panel-heading">
              <div className="container">
                <div id="packet_id" className="panel-title">
                  {pageType === "Update" && <h1 className="menu-title">Proposed Debt Issuer Update</h1>}
                  {pageType === "Review" && <h1 className="menu-title">Proposed Debt Issuer Update Review</h1>}
                </div>
              </div>
            </div>
            <div className="panel-body">
              <div className="container">
                <div className="form">
                  {isLoading && <Spinner animation="border" variant="primary" />}
                  <Row>
                    <Col md={12}>
                      <div className="control">
                        <label>CDIAC Number: </label>
                        <Typeahead
                          placeholder="Choose CDIAC Number"
                          id="proposeDebt"
                          labelKey="cdiacNumber"
                          onChange={e => handleCdiacChange(e, "proposeDebtId")}
                          inputProps={{ 'data-validations': 'required', name: 'cdiacNumber' }}
                          options={cdiacNumbers}
                          sort
                        />
                      </div>
                    </Col>
                    
                  </Row>

                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div>
                        <a href="/admin" className="dk-blue-color link-button" style={{ float: 'left' }}>Back to Admin</a>
                      </div>
                      <div style={{ float: 'right' }}>
                        <div>
                          {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleCancelChangesBtn} >
                            Cancel All Changes
                          </button>}
                        </div>
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                      <p className="error"> {cancelIssuerError}</p>
                    </div>
                  </div>
                  <hr />

                  {/* Proposed Debt grid */}
                  <div>
                    <Row>
                      {pageType === "Update" && <Col md={12}>
                        <div className="control">
                          <label>Issuer: </label>
                          <Typeahead
                            placeholder="Choose an Issuer"
                            id="issuerId"
                            labelKey="issuerName"
                            onChange={e => handleIssuerChange(e, "issuerId")}
                            inputProps={{ 'data-validations': 'required', name: 'issuerId' }}
                            options={issuers}
                            sort
                            ref={issuerClearRef}
                          />
                        </div>
                      </Col>}
                    </Row>

                    <div style={{ overflow: 'auto' }}>
                      <div className="fleft w-100">
                        <div style={{ float: 'right' }}>
                          <div>
                            {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddIssuerBtn} >
                              Add New Issuer
                            </button>}
                          </div>
                        </div>
                      </div>
                      <div style={{ float: 'right' }}>
                        {pageType === "Update" && <p className="error"> {addIssuerError}</p>}
                      </div>
                    </div>
                  </div>
                  <div>
                    <DataGrid
                      title="Current Proposed Debt:"
                      dataSource={proposeDebt}
                      sortField='ProposeDebtId'
                      showQuickSearch={false}
                      emptyDataMessage='No data available to display'
                    >
                      {columnsProposeDebt.map((column, i) => {
                        return (
                          <Column
                            key={i}
                            field={column.dataField}
                            header={column.text}
                            body={column.formatter}
                            hidden={column.hidden}
                          />)
                      })
                      }
                    </DataGrid>
                  </div>
                  <div>
                    <DataGrid
                      title="New Proposed Debt:"
                      dataSource={newProposeDebt}
                      sortField='ProposeDebtId'
                      showQuickSearch={false}
                      emptyDataMessage='No data available to display'
                    >
                      {columnsNewProposeDebt.map((column, i) => {
                        return (
                          <Column
                            key={i}
                            field={column.dataField}
                            header={column.text}
                            body={column.formatter}
                            hidden={column.hidden}
                          />)
                      })
                      }
                    </DataGrid>
                  </div>

                  <hr />

                  {/* Contact Section */}
                  <div>
                    <div>
                      {pageType === "Update" && <Row>
                        <Col md={12}>
                          <div className="control">
                            <label>Contact: </label>
                            <Typeahead
                              placeholder="Choose a Contact"
                              id="contactId"
                              labelKey="contactFullName"
                              onChange={e => handleContactChange(e, "contactId")}
                              inputProps={{ 'data-validations': 'required', name: 'contactId' }}
                              options={contacts}
                              sort
                              ref={contactClearRef}
                            />
                          </div>

                        </Col>
                      </Row>}
                      <div style={{ overflow: 'auto' }}>
                        <div className="fleft w-100">
                          <div style={{ float: 'right' }}>
                            <div>
                              {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddContactBtn} >
                                Add New Contact
                              </button>}
                            </div>
                          </div>
                        </div>
                        <div style={{ float: 'right' }}>
                          <p className="error"> {addIssuerContactError}</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <CurrentIssuerMainContact
                        onDataFetch={setIssuerContact}
                        reportId={proposeDebtId}
                        reportType={reportType}
                        ref={currentIssueContactRef}
                      />
                    </div>
                    <div>
                      <NewIssuerMainContact
                        onDataFetch={setNewIssuerContact}
                        reportId={proposeDebtId}
                        reportType={reportType}
                        ref={newIssueContactRef}
                      />
                    </div>
                  </div>

                  <hr />

                  {/* Issue Authorization Section */}
                  <div>
                    <div>
                      {pageType === "Update" && <Row>
                        <Col md={12}>
                          <div className="control">
                            <label>Authorization: </label>
                            <Typeahead
                              placeholder="Choose an Authorization"
                              id="authorizationId"
                              labelKey="authorizationFullName"
                              onChange={e => handleAuthorizationChange(e, "authorizationId")}
                              inputProps={{ 'data-validations': 'required', name: 'authorizationId' }}
                              options={authorizations}
                              sort
                              ref={AuthorizationClearRef}
                            />
                          </div>

                        </Col>
                      </Row>}
                      <div style={{ overflow: 'auto' }}>
                        <div className="fleft w-100">
                          <div style={{ float: 'right' }}>
                            <div>
                              {pageType === "Update" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleAddAuthorizationBtn} >
                                Connect Authorizations
                              </button>}
                            </div>
                          </div>
                        </div>
                        <div style={{ float: 'right' }}>
                          <p className="error"> {addIssueAuthorizationError}</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <CurrentIssueAuthorizations
                        onDataFetch={setIssueAuthorizations}
                        reportId={proposeDebtId}
                        reportType={reportType}
                        tableType={"Normal"}
                        ref={currentIssueAuthorizationRef}
                      />
                    </div>
                    <div>
                      <NewIssueAuthorizations
                        cdiacNumber={cdiacNumber}
                        onDataFetch={setNewIssueAuthorizations}
                        reportId={proposeDebtId}
                        reportType={reportType}
                        tableType={"Review"}
                        ref={newIssueAuthorizationRef}
                      />
                    </div>
                  </div>
                  <div style={{ overflow: 'auto' }}>
                    <div className="fleft w-100">
                      <div className="fleft w-50" style={{ float: 'right' }}>
                        {pageType === "Review" && <button className="custom-button bg-success text-light rounded" style={{ float: 'left' }} onClick={handleApproveIssuerUpdateBtn} >
                          Approve
                        </button>}
                        {pageType === "Review" && <button className="custom-button bg-success text-light rounded" style={{ float: 'right' }} onClick={handleRejectIssuerUpdateBtn} >
                          Reject
                        </button>}
                      </div>
                    </div>
                    <div style={{ float: 'right' }}>
                      {pageType === "Review" && <p className="error"> {addIssuerError}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </form>
    </SecurityContainer>

  )
}

export default ProposedDebtIssuerUpdate
